import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeCapcha, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import { ValidCaptcha } from "../../util/varios";
import axios from "axios";

export const ClaveSupervisor = (props) => {
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(true);
  const [deshabilitadoL, setDeshabilitadoL] = useState(false);
  const [titulo, setTitulo] = useState();
  const [idUsuario, setIdUsuario] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [activate, setActivate] = useState(false);
  const [contar, setContar] = useState(0);
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  const [tecla, setTecla] = useState();
  const [desde, setDesde] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const txtLogin = useRef();
  const txtPassword = useRef();

  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const procesarRegistro = () => {
    let endpoint = `${op.conexion}/api/comun/cambioclave/usuariotimbre`;

    let body = {
      passwd: txtPassword.current.value,
      login: txtLogin.current.value,
      idusuario: idUsuario,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          setMensaje({
            mostrar: true,
            titulo: "Cambiar Contraseña",
            texto: "La Contraseña fue cambiada.",
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Cambiar Contraseña",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SelectUsuario = (cualsup, username, password) => {
    let endpoint = `${op.conexion}/api/comun/selectusuariosupervisor?cualsup=${cualsup}&username=${username}&password=${password}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setActivate(false);
          if (response.data.idusuario > 0) {
            setIdUsuario(response.data.idusuario);
            props.onHideAceptaSup();
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "Usuario o Clave Incorrecta",
              icono: "informacion",
            });
            blanquear();
            //props.onHideCancelaSup();
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
        props.onHideCancelaSup();
      });
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
  }, []);

  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setMostrar1(false);
    setTitulo2("");
    setMsg2("");
    setActivate(false);
    setContar(0);
    setIdUsuario(0);
    txtLogin.current.value = "";
    txtPassword.current.value = "";
    txtLogin.current.focus();
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaSup();
  };

  const validarCapcha = () => {
    var valido = ValidCaptcha();
    if (valido) {
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "Esta seguro de registrar el ejercicio fiscal con estos datos?",
        icono: "confirmacion",
      });
      setMostrar4(false);
    }
  };

  const handleCancelaCapcha = () => {
    setMostrar4(false);
  };

  const handleCloseSi = () => {
    procesarRegistro();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const seleccionarUsuario = () => {
    setContar(0);
    setActivate(true);
    SelectUsuario(
      props.supervisor,
      txtLogin.current.value,
      txtPassword.current.value
    );
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtLogin.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Usuario no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtLogin.current.focus();
    } else if (txtPassword.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "La Contraseña no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtPassword.current.focus();
    }
    if (sigue) {
      seleccionarUsuario();
    }
  };

  const handleInputChange = (event) => {
    setTecla(event.which);
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputLogin") {
        //seleccionarUsuario();
        txtPassword.current.focus();
      } else if (event.target.id === "inputPassword") {
        btnAcepta.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      return false;
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const cerrarModal = () => {
    props.onHide();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const mostrarPassword = () => setMostrarClave(!mostrarClave);
  const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);

  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        txtLogin.current.focus();
        setDeshabilitado(true);
        setDeshabilitadoL(false);
        setDesde(0);
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>AUTORIZACIÓN.</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <MensajeCapcha
          show={mostrar4}
          onHideAcepta={validarCapcha}
          onHideCancela={handleCancelaCapcha}
        />
        <Dimmer active={activate} />
        <div style={{ height: "auto", overflow: "auto" }}>
          <div className="border-azul rounded">
            <div className="container">
              <div className="col-md-12">
                <div className="col-md-12 py-1">
                  <label htmlFor="validationTooltipUsername">Usuario: </label>
                  <input
                    type="text"
                    autocomplete="off"
                    disabled={deshabilitadoL}
                    ref={txtLogin}
                    className="form-control form-control-sm"
                    defaultValue={
                      props.usuario
                        ? props.usuario.usuarioByIdusuario.login
                        : ""
                    }
                    id="inputLogin"
                    onKeyUp={handleInputChange}
                  />
                </div>

                <div className="col-md-12 py-1">
                  <label htmlFor="validationTooltip02">Contraseña: </label>
                  <div className="input-group input-group-sm">
                    <input
                      type={mostrarClave ? "text" : "password"}
                      ref={txtPassword}
                      className="form-control form-control-sm"
                      id="inputPassword"
                      onKeyUp={handleInputChange}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={deshabilitado}
                      onClick={mostrarPassword}
                      className="btn btn-sm btn-info"
                    >
                      <i className="fa fa-eye-slash"></i>{" "}
                    </button>
                  </div>
                </div>
                <div className="col-md-12 py-1"></div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-md-12">
          <button
            ref={btnAcepta}
            onClick={onChangeValidar}
            className="btn btn-success col-md-6 btn-sm rounded-pill"
          >
            <i className="fas fa-check-circle"> Aceptar</i>
          </button>
          <button
            ref={btnCancela}
            onClick={cancelar}
            className="btn btn-danger col-md-6 btn-sm rounded-pill"
          >
            <i className="fas fa-window-close"> Cancelar</i>
          </button>
        </div>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Cambiar Contraseña"
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};

//export default CambiarClave;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/modalClaveSupervisor.js